/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../index.css";
import LogoOkOce from "@img/logo-okoce.webp";

function Navbar() {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [programDropdownVisible, setProgramDropdownVisible] =
    useState(false); /*Menu Program*/
  const [EtalaseDropdownVisible, setEtalaseDropdownVisible] =
    useState(false); /*Menu Etalase*/
  const [PeluangDropdownVisible, setPeluangDropdownVisible] =
    useState(false); /*Menu Peluang*/
  const [EventDropdownVisible, setEventDropdownVisible] =
    useState(false); /*Menu Event*/
  const [InformasiDropdownVisible, setInformasiDropdownVisible] =
    useState(false); /*Menu Informasi*/
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const handleDropdownShow = () => {
    setDropdownVisible(true);
  };

  const handleDropdownHide = () => {
    setDropdownVisible(false);
  };
  /*Bawah Menu Program*/
  const handleProgramDropdownShow = () => {
    setProgramDropdownVisible(true);
  };

  const handleProgramDropdownHide = () => {
    setProgramDropdownVisible(false);
  };
  /*Atas Menu Program*/

  /*Bawah Menu Etalase*/
  const handleEtalaseDropdownShow = () => {
    setEtalaseDropdownVisible(true);
  };

  const handleEtalaseDropdownHide = () => {
    setEtalaseDropdownVisible(false);
  };
  /*Atas Menu Etalase*/

  /*Bawah Menu Peluang*/
  const handlePeluangDropdownShow = () => {
    setPeluangDropdownVisible(true);
  };

  const handlePeluangDropdownHide = () => {
    setPeluangDropdownVisible(false);
  };
  /*Atas Menu Peluang*/

  /*Bawah Menu Event*/
  const handleEventDropdownShow = () => {
    setEventDropdownVisible(true);
  };

  const handleEventDropdownHide = () => {
    setEventDropdownVisible(false);
  };
  /*Atas Menu Event*/

  /*Bawah Menu Informasi*/
  const handleInformasiDropdownShow = () => {
    setInformasiDropdownVisible(true);
  };

  const handleInformasiDropdownHide = () => {
    setInformasiDropdownVisible(false);
  };
  /*Atas Menu Informasi*/

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  return (
    <>
      <nav className="border-b border-gray font-jost">
        {/* {Navbar Mobile} */}
        <div className="fixed bg-white top-0 z-50 flex items-center justify-between mx-auto p-2 max-h-24 shadow-lg w-full">
          <a href="/" className="ml-4">
            <img src={LogoOkOce} className="h-[5rem]" alt="Ok Oce Logo" />
          </a>
          <button
            data-collapse-toggle="navbar-multi-level"
            type="button"
            className="md:hidden inline-flex items-center mr-3 p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
            aria-controls="navbar-multi-level"
            aria-expanded={isDropdownVisible ? "true" : "false"}
            onClick={toggleDropdown}
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 17 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1 1h15M1 7h15M1 13h15"
              />
            </svg>
          </button>
          <div
            className={
              "absolute top-[4rem] left-0 w-full md:hidden" +
              (isDropdownVisible ? "" : " hidden")
            }
            id="navbar-multi-level"
          >
            <ul className="flex flex-col font-small p-4 md:p-0 mt-4 bg-gray-50 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white">
              <li
                onMouseEnter={handleDropdownShow}
                onMouseLeave={handleDropdownHide}
              >
                <button
                  id="dropdownNavbarLink"
                  className="uppercase flex items-center justify-between w-full py-2 px-3 text-black hover:bg-[#e01f31] rounded-lg md:hover:bg-[#e01f31] md:border-0 hover:text-white md:p-0 md:w-auto"
                >
                  Tentang Kami
                </button>

                {/*Dropdown menu */}
                <div
                  className={
                    "absolute right-4 z-100 font-normal drop-shadow-2xl divide-y rounded-lg top-[4.5rem] w-44 bg-white divide-gray-500 " +
                    (dropdownVisible ? "" : "hidden")
                  }
                >
                  <ul
                    className="py-2 text-sm text-black"
                    aria-labelledby="dropdownLargeButton"
                  >
                    <li>
                      <a
                        href="/sejarah"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Sejarah
                      </a>
                    </li>
                    <li>
                      <a
                        href="/visimisi"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Visi dan Misi
                      </a>
                    </li>
                    <li>
                      <a
                        href="/nilaiinti"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Nilai Inti
                      </a>
                    </li>
                    <li>
                      <a
                        href="/struktur"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Struktur Pengurus
                      </a>
                    </li>
                    <li>
                      <a
                        href="/penggerak"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Penggerak
                      </a>
                    </li>
                    <li>
                      <a
                        href="/anniversary"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Anniversary
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <a
                  href="/7top"
                  className="uppercase block py-2 px-3 text-gray-900 hover:bg-[#e01f31] rounded-lg md:hover:bg-[#e01f31] md:border-0 hover:text-white md:p-0 md:w-auto md:hover:text-white"
                >
                  7 Top
                </a>
              </li>
              <li
                onMouseEnter={handleEtalaseDropdownShow}
                onMouseLeave={handleEtalaseDropdownHide}
              >
                <button
                  id="dropdownEtalaseNavbarLink"
                  className="uppercase flex items-center justify-between w-full py-2 px-3 text-black hover:bg-[#e01f31] rounded-lg md:hover:bg-[#e01f31] md:border-0 hover:text-white md:w-auto md:hover:text-white"
                >
                  Etalase
                </button>

                {/*Dropdown menu */}
                <div
                  className={
                    "absolute right-4 z-100 font-normal drop-shadow-2xl divide-y divide-gray-100 rounded-lg top-[9.5rem] w-44 bg-white " +
                    (EtalaseDropdownVisible ? "" : "hidden")
                  }
                >
                  <ul
                    className="py-2 text-sm text-black"
                    aria-labelledby="dropdownEtalaseNavbarLink"
                  >
                    <li>
                      <a
                        href="/merchandise"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Merchandise
                      </a>
                    </li>
                  </ul>
                </div>
              </li>

              <li
                onMouseEnter={handlePeluangDropdownShow}
                onMouseLeave={handlePeluangDropdownHide}
              >
                <button
                  id="dropdownPeluangNavbarLink"
                  className="uppercase flex items-center justify-between w-full py-2 px-3 text-black hover:bg-[#e01f31] rounded-lg md:hover:bg-[#e01f31] md:border-0 hover:text-white md:w-auto md:hover:text-white"
                >
                  Peluang
                </button>
                {/*Dropdown menu */}
                <div
                  className={
                    "absolute right-4 z-100 font-normal drop-shadow-2xl divide-y rounded-lg top-[12rem] w-44 bg-white divide-gray-500 " +
                    (PeluangDropdownVisible ? "" : "hidden")
                  }
                >
                  <ul
                    className="py-2 text-sm text-black"
                    aria-labelledby="dropdownPeluangNavbarLink"
                  >
                    <li>
                      <a
                        href="/mitrakerjasama"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Mitra Kerjasama
                      </a>
                    </li>
                    <li>
                      <a
                        href="/peluangusaha"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Peluang Usaha
                      </a>
                    </li>
                    <li>
                      <a
                        href="/peluangkerja"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Peluang Kerja
                      </a>
                    </li>
                    <li>
                      <a
                        href="/magang"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Magang
                      </a>
                    </li>
                    <li>
                      <a
                        href="/trainer"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Trainer
                      </a>
                    </li>
                    <li>
                      <a
                        href="/mentor"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Mentor
                      </a>
                    </li>
                    <li>
                      <a
                        href="/donasi"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Donasi
                      </a>
                    </li>
                    {/* Add more submenu items here */}
                  </ul>
                </div>
              </li>

              <li
                onMouseEnter={handleEventDropdownShow}
                onMouseLeave={handleEventDropdownHide}
              >
                <button
                  id="dropdownEventNavbarLink"
                  className="uppercase flex items-center justify-between w-full py-2 px-3 text-black hover:bg-[#e01f31] rounded-lg md:hover:bg-[#e01f31] md:border-0 hover:text-white md:w-auto"
                >
                  Event
                </button>
                {/*Dropdown menu */}
                <div
                  className={
                    "absolute right-4 z-100 font-normal drop-shadow-2xl divide-y rounded-lg top-[14.5rem] w-44 bg-white divide-gray-500 " +
                    (EventDropdownVisible ? "" : "hidden")
                  }
                >
                  <ul
                    className="py-2 text-sm text-black"
                    aria-labelledby="dropdownEventNavbarLink"
                  >
                    <li>
                      <a
                        href="/event"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Daftar event
                      </a>
                    </li>
                    <li>
                      <a
                        href="/daftarberita"
                        className="ccamelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Daftar Berita
                      </a>
                    </li>
                  </ul>
                </div>
              </li>

              <li
                onMouseEnter={handleProgramDropdownShow}
                onMouseLeave={handleProgramDropdownHide}
              >
                <button
                  id="dropdownProgramNavbarLink"
                  className="uppercase flex items-center justify-between w-full py-2 px-3 text-black hover:bg-[#e01f31] rounded-lg md:hover:bg-[#e01f31] md:border-0 hover:text-white md:p-0 md:w-auto"
                >
                  Program
                </button>

                {/*Dropdown menu */}
                <div
                  className={
                    "absolute right-4 z-100 font-normal drop-shadow-2xl divide-y rounded-lg top-[17rem] w-44 bg-white divide-gray-500 " +
                    (programDropdownVisible ? "" : "hidden")
                  }
                >
                  <ul
                    className="py-2 text-sm text-black"
                    aria-labelledby="dropdownProgramNavbarLink"
                  >
                    <li>
                      <a
                        href="/lokalbrand"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Brand Lokal OK
                      </a>
                    </li>
                    <li>
                      <a
                        href="/modalberkah"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Modal Berkah
                      </a>
                    </li>
                    <li>
                      <a
                        href="/emakkece"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Emak Kece
                      </a>
                    </li>
                    <li>
                      <a
                        href="/masjidpemberdaya"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Masjid Pemberdaya
                      </a>
                    </li>
                    <li>
                      <a
                        href="/desapreneur"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Desapreneur
                      </a>
                    </li>
                    <li>
                      <a
                        href="/Thementor"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        The Mentor
                      </a>
                    </li>
                    <li>
                      <a
                        href="/mastermentor"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Master Mentor
                      </a>
                    </li>
                    {/* Add more submenu items here */}
                  </ul>
                </div>
              </li>

              <li
                onMouseEnter={handleInformasiDropdownShow}
                onMouseLeave={handleInformasiDropdownHide}
              >
                <button
                  id="dropdownInformasiNavbarLink"
                  className="uppercase flex items-center justify-between w-full py-2 px-3 text-black hover:bg-[#e01f31] rounded-lg md:hover:bg-[#e01f31] md:border-0 hover:text-white md:w-auto md:hover:text-white"
                >
                  Informasi
                </button>
                {/*Dropdown menu */}
                <div
                  className={
                    "absolute right-4 z-100 font-normal drop-shadow-2xl divide-y rounded-lg top-[19.5rem] w-44 bg-white divide-gray-500 " +
                    (InformasiDropdownVisible ? "" : "hidden")
                  }
                >
                  <ul
                    className="py-2 text-sm text-black"
                    aria-labelledby="dropdownEventNavbarLink"
                  >
                    <li>
                      <a
                        href="/faq"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        FAQ
                      </a>
                    </li>
                    <li>
                      <a
                        href="/testimoni"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Testimoni Pengguna
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <a
                href="https://ecsys.okoce.net/"
                className="mt-8 w-7/12 mx-auto"
              >
                <button
                  type="button"
                  className="w-full text-white bg-[#1c75ac] mr-6 mb-2 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-[#1c75ac] font-medium rounded-lg text-sm px-4 py-2 text-center"
                >
                  Masuk
                </button>
              </a>
              <a
                href="https://ecsys.okoce.net/register"
                className="w-7/12 mx-auto"
              >
                <button
                  type="button"
                  className="w-full text-white bg-[#e01f31] mr-6 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-[#1c75ac] font-medium rounded-lg text-sm px-4 py-2 text-center"
                >
                  Daftar
                </button>
              </a>
            </ul>
          </div>

          {/* {Navbar Laptop} */}
          <div className="w-11/12 hidden justify-center lg:inline-flex lg:flex-row lg:items-center">
            <ul className="flex flex-col text-base bg-gray-50 md:items-center md:space-x-6 md:flex-row md:mt-0 md:border-0 md:bg-white tracking-wide">
              <li
                onMouseEnter={handleDropdownShow}
                onMouseLeave={handleDropdownHide}
              >
                <button
                  id="dropdownNavbarLink"
                  className="uppercase w-full py-2 px-3 text-black hover:bg-[#e01f31] rounded-lg md:hover:bg-[#e01f31] md:border-0 hover:text-white md:w-auto md:hover:text-white focus:text-black"
                >
                  Tentang Kami
                </button>

                {/*Dropdown menu */}
                <div
                  className={
                    "absolute z-100 font-normal divide-y rounded-lg top-[4.3rem] w-44 drop-shadow-lg bg-white divide-gray-600 " +
                    (dropdownVisible ? "" : "hidden")
                  }
                >
                  <ul
                    className="py-2 text-sm text-black"
                    aria-labelledby="dropdownLargeButton"
                  >
                    <li>
                      <Link
                        to="/sejarah"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] text-black hover:text-white focus:text-white"
                      >
                        Sejarah
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/visimisi"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] text-black hover:text-white focus:text-white"
                      >
                        Visi dan Misi
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/nilaiinti"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] text-black hover:text-white focus:text-white"
                      >
                        Nilai Inti
                      </Link>
                    </li>
                    <Link
                      to="/struktur"
                      className="camelcase block px-4 py-2 hover:bg-[#e01f31] text-black hover:text-white focus:text-white"
                    >
                      Struktur Pengurus
                    </Link>
                    <li>
                      <Link
                        to="/penggerak"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] text-black hover:text-white focus:text-white"
                      >
                        Penggerak
                      </Link>
                    </li>
                    <Link
                      to="/anniversary"
                      className="camelcase block px-4 py-2 hover:bg-[#e01f31] text-black hover:text-white focus:text-white"
                    >
                      Anniversary
                    </Link>
                  </ul>
                </div>
              </li>
              <li>
                <a
                  href="/7top"
                  className="uppercase block py-2 px-3 hover:bg-[#e01f31] rounded-lg md:border-0 md:w-auto text-black hover:text-white focus:text-white"
                >
                  7 Top
                </a>
              </li>

              <li
                onMouseEnter={handleEtalaseDropdownShow}
                onMouseLeave={handleEtalaseDropdownHide}
              >
                <button
                  id="dropdownEtalaseNavbarLink"
                  className="uppercase w-full py-2 px-3 text-black hover:bg-[#e01f31] rounded-lg md:hover:bg-[#e01f31] md:border-0 md:w-auto md:hover:text-white focus:text-black"
                >
                  Etalase
                </button>

                {/*Dropdown menu */}
                <div
                  className={
                    "absolute z-100 font-normal divide-y rounded-lg top-[4.3rem] w-44 drop-shadow-lg bg-white divide-gray-600 " +
                    (EtalaseDropdownVisible ? "" : "hidden")
                  }
                >
                  <ul
                    className="py-2 text-sm text-black"
                    aria-labelledby="dropdownEtalaseNavbarLink"
                  >
                    <li>
                      <a
                        href="/merchandise"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Merchandise
                      </a>
                    </li>
                  </ul>
                </div>
              </li>

              <li
                onMouseEnter={handlePeluangDropdownShow}
                onMouseLeave={handlePeluangDropdownHide}
              >
                <button
                  id="dropdownPeluangNavbarLink"
                  className="uppercase w-full py-2 px-3 text-black hover:bg-[#e01f31] rounded-lg md:hover:bg-[#e01f31] md:border-0 md:w-auto md:hover:text-white focus:text-black"
                >
                  Peluang
                </button>
                {/*Dropdown menu */}
                <div
                  className={
                    "absolute z-100 font-normal divide-y rounded-lg top-[4.3rem] w-44 drop-shadow-lg bg-white divide-gray-600 " +
                    (PeluangDropdownVisible ? "" : "hidden")
                  }
                >
                  <ul
                    className="py-2 text-sm text-black"
                    aria-labelledby="dropdownPeluangNavbarLink"
                  >
                    <li>
                      <a
                        href="/mitrakerjasama"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Mitra Kerjasama
                      </a>
                    </li>
                    <li>
                      <a
                        href="/peluangusaha"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Peluang Usaha
                      </a>
                    </li>
                    <li>
                      <a
                        href="/peluangkerja"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Peluang Kerja
                      </a>
                    </li>
                    <li>
                      <a
                        href="/magang"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Magang
                      </a>
                    </li>
                    <li>
                      <a
                        href="/trainer"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Trainer
                      </a>
                    </li>
                    <li>
                      <a
                        href="/mentor"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Mentor
                      </a>
                    </li>
                    <li>
                      <a
                        href="/donasi"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Donasi
                      </a>
                    </li>
                    {/* Add more submenu items here */}
                  </ul>
                </div>
              </li>

              <li
                onMouseEnter={handleEventDropdownShow}
                onMouseLeave={handleEventDropdownHide}
              >
                <button
                  id="dropdownEventNavbarLink"
                  className="uppercase w-full py-2 px-3 text-black hover:bg-[#e01f31] rounded-lg md:hover:bg-[#e01f31] md:border-0 md:w-auto md:hover:text-white focus:text-black"
                >
                  Event
                </button>
                {/*Dropdown menu */}
                <div
                  className={
                    "absolute z-100 font-normal divide-y rounded-lg top-[4.3rem] w-44 drop-shadow-lg bg-white divide-gray-600 " +
                    (EventDropdownVisible ? "" : "hidden")
                  }
                >
                  <ul
                    className="py-2 text-sm text-black"
                    aria-labelledby="dropdownEventNavbarLink"
                  >
                    <li>
                      <a
                        href="/event"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Daftar Event
                      </a>
                    </li>
                    <li>
                      <a
                        href="/daftarberita"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Daftar Berita
                      </a>
                    </li>
                  </ul>
                </div>
              </li>

              <li
                onMouseEnter={handleProgramDropdownShow}
                onMouseLeave={handleProgramDropdownHide}
              >
                <button
                  id="dropdownProgramNavbarLink"
                  className="uppercase w-full py-2 px-3 text-black hover:bg-[#e01f31] rounded-lg md:hover:bg-[#e01f31] md:border-0 md:w-auto md:hover:text-white focus:text-black"
                >
                  Program
                </button>

                {/*Dropdown menu */}
                <div
                  className={
                    "absolute z-100 font-normal divide-y rounded-lg top-[4.3rem] w-44 drop-shadow-lg bg-white divide-gray-600 " +
                    (programDropdownVisible ? "" : "hidden")
                  }
                >
                  <ul
                    className="py-2 text-sm text-black"
                    aria-labelledby="dropdownProgramNavbarLink"
                  >
                    <li>
                      <a
                        href="/lokalbrand"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Brand Lokal OK
                      </a>
                    </li>
                    <li>
                      <a
                        href="/modalberkah"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Modal Berkah
                      </a>
                    </li>
                    <li>
                      <a
                        href="/emakkece"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Emak Kece
                      </a>
                    </li>
                    <li>
                      <a
                        href="/masjidpemberdaya"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Masjid Pemberdaya
                      </a>
                    </li>
                    <li>
                      <a
                        href="/desapreneur"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Desapreneur
                      </a>
                    </li>
                    <li>
                      <a
                        href="/Thementor"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        The Mentor
                      </a>
                    </li>
                    <li>
                      <a
                        href="/mastermentor"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Master Mentor
                      </a>
                    </li>
                    {/* Add more submenu items here */}
                  </ul>
                </div>
              </li>

              <li
                onMouseEnter={handleInformasiDropdownShow}
                onMouseLeave={handleInformasiDropdownHide}
              >
                <button
                  id="dropdownInformasiNavbarLink"
                  className="uppercase w-full py-2 px-3 text-black hover:bg-[#e01f31] rounded-lg md:hover:bg-[#e01f31] md:border-0 md:w-auto md:hover:text-white focus:text-black"
                >
                  Informasi
                </button>
                {/*Dropdown menu */}
                <div
                  className={
                    "absolute z-100 font-normal divide-y rounded-lg top-[4.3rem] w-44 drop-shadow-lg bg-white divide-gray-600 " +
                    (InformasiDropdownVisible ? "" : "hidden")
                  }
                >
                  <ul
                    className="py-2 text-sm text-black"
                    aria-labelledby="dropdownEventNavbarLink"
                  >
                    <li>
                      <a
                        href="/faq"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        FAQ
                      </a>
                    </li>
                    <li>
                      <a
                        href="/testimoni"
                        className="camelcase block px-4 py-2 hover:bg-[#e01f31] hover:text-white"
                      >
                        Testimoni Pengguna
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
            <div className="ml-[3rem]">
              <a
                className="text-white mr-6 focus:ring-4 focus:outline-none focus:ring-[#1c75ac] font-medium rounded-lg text-base px-4 py-2 text-center bg-[#1c75ac] hover:bg-blue-700"
                href="https://ecsys.okoce.net/"
              >
                Masuk
              </a>
              <a
                className="text-white mr-6 focus:ring-4 focus:outline-none focus:ring-[#1c75ac] font-medium rounded-lg text-base px-4 py-2 text-center bg-[#e01f31] hover:bg-red-700"
                href="https://ecsys.okoce.net/register"
              >
                Daftar
              </a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
